import React from 'react';

class FormView extends React.Component {
	hasError (name, message) {
		if (this.props.errorElements && this.props.errorElements.indexOf(name) !== -1) {
			return message;
		}
		return null;
	}
	hasAnonymousError (name) {
		return this.props.errorElements && this.props.errorElements.indexOf(name) !== -1
	}
}

export function useHasError (errorElements = []) {
	return function getError (name, message) {
		if (errorElements.indexOf(name) !== -1) {
			return message;
		}
		return null;
	}
}

export function useHasAnonymousError (errorElements = []) {
	return function hasAnonymousError (name) {
		return errorElements && errorElements.indexOf(name) !== -1
	}
}

export default FormView;
